import Vue from "vue";
import Vuex from "vuex";
import setting from "./setting";
import projects from "./projects";
import about from "./about";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    about,
    projects,
    setting,
  },
  strict: true,
});

export default store;
